import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleModal } from '../../../actions/ViewController';
import { LANDING_PAGE_URL, SERVER_URL } from '../../../config';
import { modalTypes } from '../../../consts';
import { TRootState } from '../../../reducers';


export default function Header() {
    const dispatch = useDispatch();

    const { loggedIn, userInfo } = useSelector((state: TRootState) => ({
        loggedIn: state.clientData.loggedIn,
        userInfo: state.clientData.basicInfo,
    }));

    const handleRegister = () => {
        dispatch(toggleModal('authModal', modalTypes.SIGNUP));
    };

    const handleLogin = () => {
        dispatch(toggleModal('authModal', modalTypes.LOGIN));
    };

    const renderCompanyInfo = () => {
        if (!userInfo.logo) {
            return (
                <a href={SERVER_URL} data-testid="company-name-logo">
                    {userInfo.company_name}
                </a>
            );
        }

        return (
            <a href={LANDING_PAGE_URL} className="with-logo">
                <img src={userInfo.logo} alt="main-logo" />
                {userInfo.company_name}
            </a>
        );
    };

    return (
        <div>
            <header className="white">
                <a href={LANDING_PAGE_URL}>
                    <img
                        className="logo logo--purple"
                        alt="logo"
                        src="/static/images/logo-purple.png"
                    />
                </a>
                {loggedIn ? (
                    <ul>
                        <li>
                            <a href="/jobs/list">My bookings</a>
                        </li>
                        <li>{renderCompanyInfo()}</li>
                        <li>
                            <a href={`${SERVER_URL}/account/logout`}>Log out</a>
                        </li>
                    </ul>
                ) : (
                    <ul>
                        <li>
                            <a onClick={handleRegister}>Register</a>
                        </li>
                        <li>
                            <a onClick={handleLogin}>Log in</a>
                        </li>
                    </ul>
                )}
            </header>
        </div>
    );
}
